/**
 * DOM utility functions
 */

/**
 * Checks if the given element is an input element (input, textarea, or contentEditable)
 */
export const isInputElement = (element: Element | null): boolean => {
  if (!element) return false

  return (
    element.tagName === 'INPUT' ||
    element.tagName === 'TEXTAREA' ||
    (element as HTMLElement).contentEditable === 'true'
  )
}

/**
 * Checks if the currently active element is an input element
 */
export const isActiveElementInput = (): boolean => {
  return isInputElement(document.activeElement)
}

/**
 * Checks if the currently active element is an input element with content
 * Returns false if input is focused but empty (allowing keyboard navigation)
 */
export const isActiveElementInputWithContent = (): boolean => {
  const element = document.activeElement
  if (!isInputElement(element)) return false

  // Check if the input has content
  if (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA') {
    return (
      (element as HTMLInputElement | HTMLTextAreaElement).value.trim().length >
      0
    )
  }

  // For contentEditable elements
  if ((element as HTMLElement).contentEditable === 'true') {
    return (element as HTMLElement).textContent?.trim().length ?? 0 > 0
  }

  return false
}
